import { ComponentPropsWithoutRef } from "react";
import * as styles from "./SectionBlockMediaItem.css";
import {
  type SectionBlockMediaItem as ISectionBlockMediaItem,
  type Settings,
} from "~/sanity/types";
import { Heading } from "~/components/elements/Heading";
import { ButtonLink } from "~/components/elements/ButtonLink";
import Grid from "~/components/globals/Grid";
// @ts-ignore
import ArrowOutward from "@material-design-icons/svg/filled/arrow_outward.svg?react";
import { Image, IImage } from "~/components/elements/Image";
import PortableText, {
  IPortableText,
} from "~/components/portableText/PortableText";
import { Socials } from "~/components/elements/Socials";

export type SectionBlockMediaItemProps = ComponentPropsWithoutRef<"div"> & {
  data: ISectionBlockMediaItem & { socials?: Settings["socials"] };
  inverse?: boolean;
};

export const SectionBlockMediaItem = ({
  data,
  inverse = false,
}: SectionBlockMediaItemProps) => {
  const { title, image, text, links } = data;

  return (
    <section className={styles.wrapper}>
      <Grid className={styles.grid({ inverse })}>
        <div className={styles.imageWrapper}>
          <div className={styles.imageContainer}>
            {image && (
              <Image
                image={image as IImage}
                className={styles.image}
                width={650}
              />
            )}
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.card({ inverse })}>
            <div className={styles.text}>
              <Heading as="h2" size="h1" uppercase>
                {title}
              </Heading>
              {text && <PortableText blocks={text as IPortableText} />}
            </div>
            {data.socials && (
              <Socials {...data.socials} theme="dark" isPrimary={true} size="sm" />
            )}
            {links && (
              <div className={styles.buttons}>
                {links.map(
                  (link, index) =>
                    link &&
                    link.slug && (
                      <ButtonLink
                        key={index}
                        theme={index % 2 == 0 ? "dark" : "outlineDark"}
                        link={link}
                        icons={
                          index % 2 == 0
                            ? { iconPrimary: <ArrowOutward /> }
                            : undefined
                        }
                      >
                        {link.text}
                      </ButtonLink>
                    ),
                )}
              </div>
            )}
          </div>
        </div>
      </Grid>
    </section>
  );
};
